import React from 'react';
import {Image, Tooltip} from 'antd';
import {FileOutlined,} from '@ant-design/icons';

export function validateFile(upFileName) {
    let index1 = upFileName?.lastIndexOf('.');
    let index2 = upFileName?.length;
    let suffix = upFileName?.substring(index1 + 1, index2); //后缀名
    return suffix;
}

type FileListProps = {
    img: Array<any>;
    fileUrl?: string
    uploadChange?: () => any
}

export const FileList: React.FC<FileListProps> = (props) => {
    let {fileUrl} = props;
    fileUrl = fileUrl ? fileUrl + '/' : '';

    const fileList = props.img.filter(item => Object.keys(item || {}).length);

    return (
        <div>
            {
                fileList.map((item, index) => {
                    let suffix = validateFile(item.smallUrl || item.filePath || '');
                    if (suffix == '') {
                        return ''
                    }
                    suffix = suffix.toLowerCase();
                    if (suffix == 'jpg' || suffix == 'png' || suffix == 'gif' || suffix == 'jpeg') {
                        return (
                            <div key={index}>
                                <Image style={{width: '150px', height: 100}}
                                       src={item.smallUrl ? fileUrl + item.smallUrl : fileUrl + item.filePath}/>
                                {
                                    item.fileName ? (
                                        <Tooltip title={item.fileName}>
                              <span style={{display: 'block', width: '150px', textAlign: 'center'}}>
                                {item.fileName.length > 5 ? item.fileName.slice(0, 3) + '...' : item.fileName}
                              </span>
                                        </Tooltip>
                                    ) : undefined
                                }
                                {item.fileDesc ? (
                                    <p
                                        onClick={() => {
                                            if (item.isUpload) {
                                                props.uploadChange?.();
                                            } else {
                                                return false;
                                            }
                                        }}
                                        style={{
                                            lineHeight: '21px',
                                            display: 'inline-block',
                                            height: '40px',
                                            overflowY: 'auto'
                                        }}
                                        className={item.fromDaka ? 'fromDaka' : ''}
                                    >
                                        {item.fileDesc}
                                    </p>
                                ) : (
                                    ''
                                )}
                            </div>
                        );
                    }

                    return (
                        <a
                            key={index}
                            title={item.fileName}
                            style={{display: 'inline-block', width: '100px', fontSize: '40px'}}
                            onClick={() => {
                                window.open(fileUrl + item.filePath);
                            }}
                        >
                            <FileOutlined style={{fontSize: "40px"}}/>
                            <p>{item.fileName}</p>
                        </a>
                    );
                })
            }
        </div>
    )
};
